import styled from "styled-components";

export const Container = styled.div`
  width: 110%;
  margin: ${({ theme }) => theme.spacing(16, 0)};
`;
